import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, ArrowRight } from 'lucide-react';
import { Button } from './Button';
export function Hero() {
  return <section className="relative w-full bg-stone-50 pt-12 pb-10 md:pt-32 md:pb-24 overflow-hidden" data-id="element-61" data-mp="ei1unjxvvyww">
      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-62" data-mp="9igvb8esxojn">
        <div className="max-w-4xl mx-auto text-center" data-id="element-63" data-mp="4n9wadwh9812">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-64" data-mp="12a0ljc9tg2v5">
            <span className="inline-flex items-center gap-2 py-1.5 md:py-2 px-4 md:px-5 rounded-full bg-teal-600 text-white text-sm md:text-lg font-semibold mb-4 md:mb-6" data-id="element-65" data-mp="nc88qrvnlskn">
              <svg className="w-4 h-4 md:w-5 md:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-66" data-mp="3d2tqpg8vwwhp">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" data-id="element-67" data-mp="3j923fiwkdgsw" />
              </svg>
              ORDEN FINANCIERO™
            </span>
            <h1 className="font-display text-3xl md:text-6xl font-extrabold text-gray-900 tracking-tight mb-3 md:mb-6 leading-[1.1]" data-id="element-68" data-mp="30hhsdush5r38">
              Detén la fuga de dinero y{' '}
              <span className="relative inline-block" data-id="element-69" data-mp="2qjv4wjx40r7n">
                <span className="relative z-10" data-id="element-70" data-mp="2qlepgmpstof8">recupera el control</span>
                <motion.span initial={{
                scaleX: 0
              }} animate={{
                scaleX: 1
              }} transition={{
                duration: 0.5,
                delay: 0.5,
                ease: [0.23, 1, 0.32, 1]
              }} className="absolute left-0 bottom-0.5 md:bottom-1.5 h-1.5 md:h-3 w-full origin-left bg-teal-200/80 rounded-sm" data-id="element-71" data-mp="2vjzpom51w83o" />
              </span>{' '}
              de tus finanzas hoy mismo.
            </h1>
            <p className="text-base md:text-2xl text-gray-600 mb-6 md:mb-10 max-w-3xl mx-auto leading-relaxed font-medium" data-id="element-72" data-mp="ddne9xklijhu">
              Implementa la herramienta sencilla en Google Sheets para
              identificar dónde pierdes dinero, proyectar tus pagos y empezar a
              ahorrar sin estrés{' '}
              <span className="font-bold text-gray-800" data-id="element-73" data-mp="111okv0y7rpum">
                
              </span>
              .
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="flex flex-col gap-3 md:gap-4 mb-6 md:mb-10 text-gray-700 max-w-2xl mx-auto" data-id="element-74" data-mp="x3h260k6wegs">
            {['Identifica fugas de dinero en menos de 5 minutos.', 'Proyecta tus gastos antes de comprar y evita sorpresas a fin de mes.', 'Sin fórmulas complicadas: llena los datos y el sistema hace todo por ti.'].map((item, index) => <div key={index} className="flex items-center gap-2 md:gap-3 text-left" data-id="element-75" data-mp="2g258wyoth71h" data-mpi={index}>
                <CheckCircle2 className="w-5 h-5 md:w-6 md:h-6 text-teal-600 flex-shrink-0" data-id="element-76" data-mp="2ozz5maqhu2p6" />
                <span className="font-medium text-base md:text-lg" data-id="element-77" data-mp="2u03lbyjkutec">{item}</span>
              </div>)}
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} data-id="element-78" data-mp="unrb2yi33ntx">
            <Button href="#precio" className="group !py-4 !text-sm md:!text-base" data-id="element-79" data-mp="3vgvwyrmxhf5q">
              SÍ, QUIERO ORDENAR MIS FINANZAS HOY
              <ArrowRight className="ml-2 w-4 h-4 md:w-5 md:h-5 group-hover:translate-x-1 transition-transform" data-id="element-80" data-mp="e77hxnlzdbi0" />
            </Button>
            <p className="mt-3 md:mt-4 text-xs md:text-sm text-gray-500" data-id="element-81" data-mp="3hpqyvtz7kuxi">
              Acceso digital inmediato · Sistema en la nube (Google Sheets) ·
              Pago único
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}